import { isNativePlatform } from "@/utils/native";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
} from "@heroui/react";
import { useMediaQuery } from "@mantine/hooks";
import { Info } from "lucide-react";

type LimeInfoTooltipProps = {
  ariaLabel?: string;
  content: React.ReactNode;
  iconSize?: number;
  placement?: "bottom" | "left" | "right" | "top";
  showArrow?: boolean;
  maxWidth?: string;
  /** What the trigger shows instead of the info icon. */
  children?: React.ReactNode;
};

export function LimeInfoTooltip({
  ariaLabel = "Information",
  content,
  iconSize = 14,
  placement = "right",
  showArrow = false,
  maxWidth,
  children,
}: LimeInfoTooltipProps) {
  const isPressTrigger =
    useMediaQuery(
      "(max-width: 768px), (hover: none), (pointer: coarse)",
      isNativePlatform(),
    ) ?? isNativePlatform();

  const trigger = (
    <button
      type="button"
      className="text-default-400 transition-colors hover:text-default-600 active:text-default-600"
      aria-label={ariaLabel}
    >
      {children ?? <Info size={iconSize} aria-hidden="true" />}
    </button>
  );

  if (isPressTrigger) {
    return (
      <Popover placement={placement} showArrow={showArrow}>
        <PopoverTrigger>{trigger}</PopoverTrigger>
        <PopoverContent
          className={maxWidth ? `max-w-[${maxWidth}]` : undefined}
        >
          {content}
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <Tooltip
      content={content}
      placement={placement}
      delay={150}
      showArrow={showArrow}
      className={maxWidth ? `max-w-[${maxWidth}]` : undefined}
    >
      {trigger}
    </Tooltip>
  );
}
